import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Typography, Button, OutlinedInput, TextField, InputAdornment, TextareaAutosize, Popover, useMediaQuery, 
    FormControlLabel, IconButton, Card, Box, Tooltip, Checkbox,FormGroup, FormControl, InputLabel,FormHelperText, FormLabel, RadioGroup, Radio, 
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { ChromePicker } from 'react-color';
import * as Yup from 'yup';
import { Formik } from 'formik';
import AuthUser from '../../../../Components/Auth/AuthUser';

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
const ColorPickerRow = ({ label, color, onChange,disabled  }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
   
    const open = Boolean(anchorEl);
    
    return (

        <Grid container item lg={12} md={12} sm={12} xs={12} alignItems="center" spacing={1} sx={{ borderBottom: '1px solid #ccc', py: 1, px: 1 }}>
            <Grid item xs={7}>
                <Typography sx={{ color: disabled ? 'text.disabled' : 'text.primary' }}>{label}</Typography>
            </Grid>
            <Grid item>
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: 0,
                        backgroundColor: color,
                        border: 'none',
                    }}
                />
            </Grid>
            <Grid item>
                <IconButton size="small" onClick={handleOpen} disabled={disabled}>
                    <EditIcon />
                </IconButton>
                <Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
                    <ChromePicker color={color} onChange={(updatedColor) => onChange(updatedColor.hex)} />
                </Popover>
            </Grid>
        </Grid>

    );
};

function ServiceStep1({ onNext,formData, fetchMedia,parsedBusinessUrl }) {
    // console.log("formData",formData);
    const isMobile = useMediaQuery('(max-width:600px)');
    const { user, validateRoles } = AuthUser();
    const [has_logo, setHasLogo] = useState("yes");
    const [brand_name, setBrandName] = useState("");
    const [companyId, setCompanyId] = React.useState(user.roles_id == 3 || user.roles_id == 4 || user.roles_id == 5 ? user.company_master_id : '');
    const fileInputRef = React.useRef(null);
    const [fileName, setFileName] = useState("");
    const companyDetails = JSON.parse(localStorage.getItem('company'));
    const websiteIsSet= parsedBusinessUrl.website;
    const instagramIsSet= parsedBusinessUrl.instagram;
    const youtubeIsSet= parsedBusinessUrl.youtube;
    const otherIsSet= parsedBusinessUrl.other || [''];
    console.log("companyDetails",companyDetails);
    const [colors, setColors] = useState({
        primary: '#FF69B4',
        secondary: '#90EE90',
        background: '#665055',
        icon: '#90EE90',
        border: '#90EE90',
    });
  
        const [otherLinks, setOtherLinks] = useState([""]);
            const handleCheckboxChange = (event, setFieldValue) => {
            const { name, checked } = event.target;
            setFieldValue(`selectedOptions.${name}`, checked);
             // When unchecked, clear the associated field values
                if (!checked) {
                    switch (name) {
                    case "website":
                        setFieldValue("websiteLink", null); // or "" if using string
                        break;
                    case "instagram":
                        setFieldValue("instagramLink", null);
                        break;
                    case "youtube":
                        setFieldValue("youtubeLink", null);
                        break;
                    case "other":
                        setFieldValue("otherLinks", [""]);
                        setOtherLinks([""]); // if you are using local state
                        break;
                    default:
                        break;
                    }
                }
            };

        const handleOtherLinkChange = (index, value) => {
            const updatedLinks = [...otherLinks];
            updatedLinks[index] = value;
            setOtherLinks(updatedLinks);
        };

        const addOtherLink = () => {
            setOtherLinks([...otherLinks, ""]);
        };

        const removeOtherLink = (index) => {
            const updatedLinks = [...otherLinks];
            updatedLinks.splice(index, 1);
            setOtherLinks(updatedLinks);
        };

    const handleColorChange = (key) => (newColor) => {
        setColors((prev) => ({ ...prev, [key]: newColor }));
    };
    const instagramRegex = /^(https?:\/\/)?(www\.)?(instagram\.com)[\w\-\/?=&.]*$/i;
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)[\w\-\/?=&.]*$/i;
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?$/;
    const validationSchema = Yup.object().shape({
        brand_name: Yup.string()
            .required("We'll use this for your logo + video intros."),
        ideal_client:Yup.string()
            .required('Examples: Busy parents, new business owners, or people denied for loans.'), 
        what_you_do: Yup.string()
            .required('Keep it simple, like “I help people fix their credit” or “I help businesses get funding fast.'), 
        // business_url: Yup.string()
        //     .url('Please Enter A Valid URL.')
        //     .required('Helps us vibe check your brand.'),
        company_name: Yup.string().when('has_logo', {
            is: false,
            then: (schema) => schema.required('Please Enter Company Name.'),
            otherwise: (schema) => schema.notRequired(),
        }),
        logo: Yup.mixed().when(['has_logo', 'is_logo_editable'], {
        is: (has_logo, is_logo_editable) => has_logo === true && is_logo_editable === true,
        then: (schema) => schema.required('Please Upload A Logo.'),
        otherwise: (schema) => schema.notRequired(),
        }),
        selectedOptions: Yup.object().shape({
            website: Yup.boolean(),
            instagram: Yup.boolean(),
            youtube: Yup.boolean(),
            other: Yup.boolean(),
        })
        .test(
                'at-least-one-checked',
                'At least one link option must be selected.',
                (value) => Object.values(value).some(Boolean)
            ),

            websiteLink: Yup.string().when('selectedOptions.website', {
                is: true,
                then: (schema) =>
                schema
                    .required('Website link is required')
                    .matches(urlRegex, 'Enter a valid URL'),
                otherwise: (schema) => schema.notRequired(),
            }),

            instagramLink: Yup.string().when('selectedOptions.instagram', {
                is: true,
                then: (schema) =>
                schema
                    .required('Instagram link is required')
                    .matches(instagramRegex, 'Enter a valid Instagram URL'),
                otherwise: (schema) => schema.notRequired(),
            }),

            youtubeLink: Yup.string().when('selectedOptions.youtube', {
                is: true,
                then: (schema) =>
                schema
                    .required('YouTube link is required')
                    .matches(youtubeRegex, 'Enter a valid YouTube URL'),
                otherwise: (schema) => schema.notRequired(),
            }),

            otherLinks: Yup.array().when('selectedOptions.other', {
                is: true,
                then: (schema) =>
                schema
                    .of(
                    Yup.string()
                        .required('Link is required')
                        .matches(urlRegex, 'Enter a valid URL'),
                    ),
                otherwise: (schema) => schema.notRequired(),
            }),
             suggestions: Yup.string()
            .max(512, 'Suggestions cannot be more than 512 characters'),
            tagline:Yup.string()
               .max(100, 'Tag Line cannot be more than 100 characters'),
    })
    // const handleUploadFile = (event) => {
    //         setIsSubmitting(true);
    //         const file = event.target.files[0];
        
    //         if (!file) {
    //             return; // If no file is selected, just return.
    //         }
    //         // added file type validation start here
    //         const validFileTypes = ['image/jpeg', 'image/png', 'image/gif'];
    //         if (!validFileTypes.includes(file.type)) {
    //             alert('Only JPEG, PNG, or GIF image formats are allowed.');
    //             fileInputRef.current.value = null;
                
    //             return;
    //         }
    //         // added file type validation end here
    //         const img = new Image();
    //         img.src = URL.createObjectURL(file)
    //         img.onload = () => {			
    //             if (img.width != 300 || img.height != 90) {
    //                 alert('Image must be 300px in width and 90px in height.');
    //                 event.target.value = null;
    //                 fileInputRef.current.value = null;
    //                 document.getElementById("uploadedLogo").value = '';
    //                 setImageUrl(config.BASE_URL+'uploadLogo.png');
    //                 setImageFile(null);
    //                 setFileName('');
    //                 setIsChange(false);
    //             }else{
    //                 setFileName(file.name);
    //                 setImageFile(file);
    //                 setImageUrl(img.src);
    //                 setLogoFlag(false);
    //                 setIsChange(true);
    //             }
    //         };
    //     };
    return (
        <>
            <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                <Typography variant="h6" fontWeight={"bolder"} sx={{ textTransform: "capitalize" }}>This helps us tailor everything to your brand.</Typography>
            </Grid>
            <Formik
                initialValues={{
                    company_master_id:companyId,
                    brand_name: formData ? formData.brand_name ? formData.brand_name:companyDetails.company_name :companyDetails.company_name,
                    ideal_client: formData ? formData.ideal_client?formData.ideal_client:"":"",
                    what_you_do: formData ? formData.what_you_do?formData.what_you_do:"":"",
                    // business_url:formData ? formData.business_url?formData.business_url:"":"",
                    has_logo:  formData?.has_logo ?? true,
                    logo:formData ? formData.logo?formData.logo:"":"",
                    company_name:formData ? formData.company_name?formData.company_name:"":"",
                    tagline: formData ? formData.tagline?formData.tagline:"":"",
                    reference_image: formData ? formData.reference_image?formData.reference_image:"":"",
                    primary_color: formData ? formData.primary_color?formData.primary_color:"#000000":"#000000",
                    secondary_color: formData ? formData.secondary_color?formData.secondary_color:"#000000":"#000000",
                    suggestions: formData ? formData.suggestions?formData.suggestions:"":"",
                    selectedOptions: {
                        website:  formData ?. selectedOptions?.website ? true : false,
                        instagram:  formData ?. selectedOptions?.instagram ? true : false,
                        youtube: formData ?. selectedOptions?.youtube ? true : false,
                        other:  formData ?. selectedOptions?. other ? true : false,
                    },
                    websiteLink: formData ? formData.websiteLink?formData.websiteLink:"":"",
                    instagramLink: formData ? formData.instagramLink?formData.instagramLink:"":"",
                    youtubeLink: formData ? formData.youtubeLink?formData.youtubeLink:"":"",
                    otherLinks: Array.isArray(formData?.otherLinks) && formData.otherLinks.length > 0 
                    ? formData.otherLinks 
                    : [''],
                    is_logo_editable: fetchMedia?.has_logo != 1,
                }}
                validationSchema={validationSchema}
                onSubmit={(values, errors) => {
                    if(values.has_logo === false){
                        delete values.logo;
                    }else{
                        delete values.company_name;
                        delete values.tagline;
                        delete values.reference_image;
                        delete values.primary_color;
                        delete values.secondary_color;
                    }
                    onNext(values); 
                }}
            >
                {({ values, errors, touched, dirty, handleChange, handleBlur, setFieldTouched, handleSubmit, setFieldValue, setFieldError }) => (
                    <form onSubmit={handleSubmit} style={{width:"100%"}}>
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                    margin='dense'
                                    fullWidth
                                    size='small'
                                    label="Name Of The Business?*"
                                    helperText={ touched.brand_name && errors.brand_name
                                                ? errors.brand_name:"We'll use this for your logo + video intros."
                                                }
                                    name="brand_name"
                                    sx={{ textTransform: "capitalize" }}
                                    value={values.brand_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={fetchMedia.brand_name}
                                    error={touched.brand_name && Boolean(errors.brand_name)}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                    margin='dense'
                                    fullWidth
                                    size='small'
                                    label="What do you help people do?*"
                                    helperText={touched.what_you_do && errors.what_you_do ? 
                                        errors.what_you_do : "Keep it simple, like “I help people fix their credit” or “I help businesses get funding fast."}
                                    name='what_you_do'
                                    value={values.what_you_do}
                                    sx={{ textTransform: "capitalize" }}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={fetchMedia.what_you_do}
                                    error={touched.what_you_do && Boolean(errors.what_you_do)}
                               />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                    margin='dense'
                                    fullWidth
                                    size='small'
                                    sx={{ textTransform: "capitalize" }}
                                    label="Who Is Your Ideal Client?*"
                                    helperText={touched.ideal_client && errors.ideal_client ?
                                                errors.ideal_client :"Examples: Busy parents, new business owners, or people denied for loans."}
                                    name="ideal_client"
                                    value={values.ideal_client}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={fetchMedia.ideal_client}
                                    error={touched.ideal_client && Boolean(errors.ideal_client)}
                                />
                            </Grid>
                        </Grid>
                        {/* <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} spacing={isMobile ? 0 : 2}> */}
                        
                            <Grid item lg={12} md={12} sm={12} xs={12} mt={isMobile?1:3} sx={{textTransform:"capitalize"}}>
                               <Grid container spacing={2} sx={{border:"2px solid #2E67BC",borderRadius:"10px"}}>
                                    {/* Website */}
                                    <Grid item xs={12} sm={6} pr={1}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={values.selectedOptions.website}
                                             onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                                            name="website"
                                            disabled={websiteIsSet}
                                            />
                                        }
                                        label="Add Your Website Link"
                                        />
                                        {values.selectedOptions.website && (
                                        <TextField
                                            label="Your Website Link"
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            name="websiteLink"
                                            value={values.websiteLink}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={websiteIsSet}
                                            error={touched.websiteLink && Boolean(errors.websiteLink)}
                                            helperText={touched.websiteLink && errors.websiteLink}
                                        />
                                        )}
                                    </Grid>

                                    {/* Youtube */}
                                    <Grid item xs={12} sm={6} pr={1}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={values.selectedOptions.youtube}
                                            onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                                            name="youtube"
                                            disabled={youtubeIsSet}
                                            />
                                        }
                                        label="Add Your Youtube Link"
                                        />
                                        {values.selectedOptions.youtube && (
                                        <TextField
                                            label="Youtube Link"
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            name="youtubeLink"
                                            value={values.youtubeLink}
                                            disabled={youtubeIsSet}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched.youtubeLink && Boolean(errors.youtubeLink)}
                                            helperText={touched.youtubeLink && errors.youtubeLink}
                                        />
                                        )}
                                    </Grid>

                                    {/* Instagram */}
                                    <Grid item xs={12} sm={6} pr={1} mb={1}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={values.selectedOptions.instagram}
                                            onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                                            name="instagram"
                                            disabled={instagramIsSet}
                                            />
                                        }
                                        label="Add Your Instagram Link"
                                        />
                                        {values.selectedOptions.instagram && (
                                        <TextField
                                            label="Instagram Link"
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            name="instagramLink"
                                            value={values.instagramLink}
                                            disabled={instagramIsSet}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched.instagramLink && Boolean(errors.instagramLink)}
                                            helperText={touched.instagramLink && errors.instagramLink}
                                        />
                                        )}
                                    </Grid>

                                    {/* Other Social Media Links */}
                                    <Grid item xs={12} sm={6}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={values.selectedOptions.other}
                                            onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                                            name="other"
                                            disabled={Array.isArray(otherIsSet) && otherIsSet.some(link => link?.trim())}
                                            />
                                        }
                                        label="Add Your Other Social Media Links"
                                        />
                                        {values.selectedOptions.other &&
                                        otherLinks.map((link, index) => (
                                            <Grid container spacing={1} key={index} mb={1}>
                                            <Grid item xs={9}>
                                                <TextField
                                                label={`Other Social Media Link`}
                                                name={`otherLinks[${index}]`}
                                                fullWidth
                                                size="small"
                                                margin="dense"
                                                value={values.otherLinks[index]}
                                                disabled={Array.isArray(otherIsSet) && otherIsSet.some(link => link?.trim())}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={
                                                    touched.otherLinks?.[index] &&
                                                    Boolean(errors.otherLinks?.[index])
                                                }
                                                helperText={
                                                    touched.otherLinks?.[index] && errors.otherLinks?.[index]
                                                }
                                                />
                                            </Grid>
                                            <Grid item xs={3} display="flex" alignItems="center">
                                                {index > 0 && (
                                                <IconButton onClick={() => removeOtherLink(index)}>
                                                    <DeleteOutline fontSize="small" />
                                                </IconButton>
                                                )}
                                                {index === otherLinks.length - 1 && otherLinks.length < 5 && (
                                                <IconButton onClick={addOtherLink}>
                                                    <AddCircleOutlineIcon fontSize="small" />
                                                </IconButton>
                                                )}
                                            </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                                {touched.selectedOptions && typeof errors.selectedOptions === 'string' && (
                                    <Typography color="error" variant="caption">
                                        {errors.selectedOptions}
                                    </Typography>
                                    )}
                            </Grid>
                        {/* </Grid> */}
                        <Grid container item  mt={2}>
                            <Grid item container lg={12} md={12} sm={12} xs={12}>
                                <FormLabel sx={{ color: "black",textTransform:"capitalize" }}>Do you already have a logo?*</FormLabel>
                            </Grid>
                            {values.has_logo === true && (
                                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                                    As you have selected 'Yes', it indicates that you are not opting for our logo design service. Kindly upload your logo here.
                                    </Typography>
                            )}
                            <RadioGroup
                                    sx={{width:"100%"}}
                                    row
                                    value={values.has_logo}
                                    onChange={(e) => setFieldValue('has_logo', e.target.value === 'true')}
                                >
                                    <Grid container item lg={12} md={12} sm={12} xs={12}spacing={2}>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <FormControlLabel
                                                value="true"
                                                sx={{ textTransform: "capitalize" }}
                                                control={<Radio />}
                                                // control={<Radio  checked={values.has_logo === true} onChange={(e) => {setFieldValue('has_logo',true);}} defaultChecked />}
                                                label="Yes"
                                                disabled={fetchMedia.has_logo == 1}
                                            />
                                        </Grid>

                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <FormControlLabel
                                                value="false"
                                                sx={{ textTransform: "capitalize" }}
                                                control={<Radio />}
                                                // control={<Radio checked={values.has_logo === false} onChange={(e) =>{setFieldValue('has_logo', false);}} />}
                                                label="No, Create One For Me"
                                                disabled={fetchMedia.has_logo == 2}
                                            />
                                        </Grid>
                                    </Grid>
                            </RadioGroup>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12}>

                            <Grid item lg={6} md={6} sm={12} xs={12}> 
                                {values.has_logo === true && (
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <FormControl variant="outlined" fullWidth margin="dense" sx={{ textTransform: "capitalize" }} size="small" error={touched.logo && Boolean(errors.logo)}>
                                    <InputLabel htmlFor="uploadedLogoStep3">Upload your logo</InputLabel>
                                    <OutlinedInput
                                    id="uploadedLogoStep3"
                                    type="text"
                                    name="logo"
                                    sx={{ width: "60%" }}
                                    value={values.logo?.name || ""}
                                    disabled={fetchMedia.has_logo == 1}
                                    endAdornment={
                                        <InputAdornment position="end">
                                        <Tooltip title="Upload your logo">
                                            <IconButton edge="end" onClick={() => fileInputRef.current?.click()}>
                                            <img
                                                src={require("../../../../assets/icons/uploadIcon.png")}
                                                style={{ height: "15px" }}
                                                alt="Upload"
                                            />
                                            </IconButton>
                                        </Tooltip>
                                        </InputAdornment>
                                    }
                                    label="Upload your logo"
                                    />
                                    {touched.logo && errors.logo && fetchMedia.has_logo != 1 && (
                                    <FormHelperText>{errors.logo}</FormHelperText>
                                    )}
                                    <input
                                    ref={fileInputRef}
                                    type="file"
                                    name="logo"
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        e.target.value = null;
                                        if (file) {
                                            const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
                                            if (!allowedTypes.includes(file.type)) {
                                                alert("Only JPEG, PNG, or GIF image files are allowed.");
                                                return;
                                            }
                                        const img = new Image();
                                        img.onload = () => {
                                            if (img.width === 300 && img.height === 90) {
                                            setFieldValue("logo", file);
                                            } else {
                                            alert("Logo must be exactly 300x90 pixels.");
                                            }
                                        };
                                        img.src = URL.createObjectURL(file);
                                        }
                                    }}
                                    style={{ display: "none" }}
                                    disabled={fetchMedia.has_logo == 1}
                                    />
                                </FormControl>
                                </Grid>
                            )}
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                {values.has_logo === false && (
                                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <TextField
                                                    margin='dense'
                                                    fullWidth
                                                    size='small'
                                                    label="Company Name*"
                                                    name='company_name'
                                                    sx={{ textTransform: "capitalize" }}
                                                    value={values.company_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched.company_name && Boolean(errors.company_name)}
                                                    helperText={errors.company_name}
                                                    disabled={fetchMedia?.logo_config?.company_name}
                                                />
                                            </Grid>
                                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <FormControl variant="outlined" fullWidth margin="dense" size="small">
                                                    <InputLabel htmlFor="uploadedLogoStep3">Reference Image(Optional)</InputLabel>
                                                    <OutlinedInput
                                                        id="uploadedLogoStep3"
                                                        type="text"
                                                        name="reference_image"
                                                        value={values.reference_image?.name || ""}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                            <Tooltip title="Upload your logo">
                                                                <IconButton edge="end" onClick={() => fileInputRef.current?.click()}>
                                                                <img
                                                                    src={require("../../../../assets/icons/uploadIcon.png")}
                                                                    style={{ height: "15px" }}
                                                                    alt="Upload"
                                                                />
                                                                </IconButton>
                                                            </Tooltip>
                                                            </InputAdornment>
                                                        }
                                                        label="Reference Image(Optional)"
                                                        />
                                                        <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        name="reference_image"
                                                        accept="image/png, image/jpeg, image/jpg"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            e.target.value = null;
                                                            if (file) {
                                                            const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
                                                            if (!allowedTypes.includes(file.type)) {
                                                                alert("Only JPEG, PNG, or GIF image files are allowed.");
                                                                return;
                                                            }
                                                            const img = new Image();
                                                            img.onload = () => {
                                                                setFieldValue("reference_image", file);
                                                            };
                                                            img.src = URL.createObjectURL(file);
                                                            }
                                                        }}
                                                        style={{ display: "none" }}
                                                        />
                                                </FormControl>
                                            </Grid>
                                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <FormControl fullWidth size="small" margin='dense'>
                                                    <TextareaAutosize
                                                        style={{ width: "100%",textTransform:"capitalize" }}
                                                        margin="dense"
                                                        aria-label="minimum height"
                                                        minRows={3}
                                                        placeholder="Suggestions if any"
                                                        name="suggestions"
                                                        value={values.suggestions}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        disabled={fetchMedia?.logo_config?.suggestions}
                                                    />
                                                    {touched.suggestions && errors.suggestions ? <Typography color="error" variant="caption" textTransform={"capitalize"}>{errors.suggestions}</Typography> : null}
                                                </FormControl>
                                            </Grid>

                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                             <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <TextField
                                                    margin='dense'
                                                    fullWidth
                                                    size='small'
                                                    sx={{ textTransform: "capitalize" }}
                                                    label="Tag line if any (Optional)"
                                                    name='tagline'
                                                    value={values.tagline}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={fetchMedia?.logo_config?.tagline}
                                                />
                                                {touched.tagline && errors.tagline ?   <Typography color="error" variant="caption" textTransform={"capitalize"}>{errors.tagline}</Typography> : null}
                                            </Grid>
                                              <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Card sx={{ border: "1px solid black", borderRadius: "10px", padding: 1 }}>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <ColorPickerRow label="Primary Color" color={values.primary_color} onChange={(color) => setFieldValue("primary_color", color)} disabled={fetchMedia?.logo_config?.primary_color}/>
                                                    <ColorPickerRow label="Secondary Color" color={values.secondary_color} onChange={(color) => setFieldValue("secondary_color", color)} disabled={fetchMedia?.logo_config?.secondary_color} />
                                                </Grid>
                                            </Card>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            <Button variant="contained" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} type='submit'>Next</Button>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    )
}
export default ServiceStep1;